import { render, staticRenderFns } from "./LabelBannerSection.vue?vue&type=template&id=035780bc&scoped=true&"
import script from "./LabelBannerSection.vue?vue&type=script&lang=js&"
export * from "./LabelBannerSection.vue?vue&type=script&lang=js&"
import style0 from "./LabelBannerSection.vue?vue&type=style&index=0&id=035780bc&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035780bc",
  null
  
)

export default component.exports